// React Query hooks for customer CRUD.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from './customers.api';

export const CUSTOMERS_KEY = 'customers';

export function useCustomers(query: api.CustomerListQuery) {
  return useQuery({
    queryKey: [CUSTOMERS_KEY, query],
    queryFn: () => api.listCustomers(query),
    placeholderData: (prev) => prev,
  });
}

export function useCreateCustomer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: api.CreateCustomerInput) => api.createCustomer(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: [CUSTOMERS_KEY] }),
  });
}

export function useUpdateCustomer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: api.UpdateCustomerInput }) =>
      api.updateCustomer(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: [CUSTOMERS_KEY] }),
  });
}

export function useDeleteCustomer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deleteCustomer(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [CUSTOMERS_KEY] }),
  });
}
